/**
  * Ingests a map and converts its values and keys into a serialized JSON string
  *
  * @param map This is a map that we can ingest and serialzie
  *
  * @returns string This is the serialzied JSON string
  */
export const serializeMapToJson = (map) => {
    const literal = {};
    map.forEach((value, key) => {
        literal[key] = value;
    });
    return JSON.stringify(literal);
};
/**
  * Handles deserializing a JSON string into a map.
  *
  * @param json The soruce JSON string
  *
  * @returns SerializableMap this is the resulting structure from the objects properties
  */
export const deserializeMapFromJson = (json) => {
    const deserialized = JSON.parse(json);
    const converted = new Map();
    Object.keys(deserialized).forEach((key) => {
        converted.set(key, deserialized[key]);
    });
    return converted;
};
